<div class="confirmation">
  <h3  mat-dialog-title
  class="text-secondary title-9 uppercase pl-0 mt-1 mb-1 text-w-700 justify-content-center">{{data.title}}</h3>
  <p class="data-message text-tertiary center" [innerHtml]=data.msg></p>
</div>
<mat-dialog-actions align="center" class="action-buttons">
  <button
    mat-raised-button
    (click)="close('confirm')"
    cdkFocusInitial
    class="primary-button"
  >
    {{ data.confirmButtonText }}
  </button>

  <button
    *ngIf="data.showCancelButton"
    (click)="close('cancel')"
    mat-raised-button
    class="secondary-button cancel-button uppercase"
  >
    {{data.cancelButtonText }}
  </button>
</mat-dialog-actions>
